import { render, staticRenderFns } from "./toggle.vue?vue&type=template&id=be561808&scoped=true&"
import script from "./toggle.vue?vue&type=script&lang=js&"
export * from "./toggle.vue?vue&type=script&lang=js&"
import style0 from "./toggle.vue?vue&type=style&index=0&id=be561808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be561808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be561808')) {
      api.createRecord('be561808', component.options)
    } else {
      api.reload('be561808', component.options)
    }
    module.hot.accept("./toggle.vue?vue&type=template&id=be561808&scoped=true&", function () {
      api.rerender('be561808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/selection-control/toggle/toggle.vue"
export default component.exports